var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.002 512.002"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.267 197.258a14.995 14.995 0 0 0-12.107-10.209l-158.723-23.065-70.985-143.827a14.998 14.998 0 0 0-26.901 0l-70.988 143.827-158.72 23.065a14.998 14.998 0 0 0-8.312 25.585l114.848 111.954-27.108 158.083a14.999 14.999 0 0 0 21.763 15.812l141.967-74.638 141.961 74.637a15 15 0 0 0 21.766-15.813l-27.117-158.081 114.861-111.955a14.994 14.994 0 0 0 3.795-15.375z"
  })));
};
export default SvgStar;